module.exports = __webpack_public_path__ + "img/viktoria-plzen-logo-icon.9481d806.png";